import { gql } from '@apollo/client';

export const USER_LEASES_QUERY = gql`
  query GetLeasesQuery($first: Int, $after: Int) {
    resident {
      leases(first: $first, after: $after) {
        edges {
          node {
            rentLeaseId
            dateSigned
            documentUri
          }
        }
      }
    }
  }
`;
